<div [attr.appTheme]="theme">
  <router-outlet></router-outlet>
</div>
